import Vue from "vue";
import VueRouter from "vue-router";
import routes from './routes'
import { mergeStickyQuery, resolveTargetRoute } from '@/helpers/redirect-query'
Vue.use(VueRouter);


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


// Auth logic

router.beforeEach((to, from, next) => {
    // keep sticky query keys (referral, program, course) while navigating
    const mergedQuery = mergeStickyQuery(to.query, from.query);
    if (mergedQuery) {
        next({ name: to.name, params: to.params, query: mergedQuery });
        return;
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to welcome page.
        if ( !window.localStorage.getItem('tK') ) {
            next({ name: 'welcome', query: to.query })
        } else {
            next() // go to wherever I'm going
        }
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        if (window.localStorage.getItem('tK')) {
            const target = resolveTargetRoute(to.query);
            next(target || { name: 'home', query: to.query })
        } else {
            next() // go to wherever I'm going
        }
    } else {
        next() // does not require auth or guest, make sure to always call next()!
    }
})

export default router;
